"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFindByKeyUsingArray = exports.toMap = void 0;
/**
 * Converts an array into a map. Assumes that each item in the array has
 * a key property and that the key property is unique.
 *
 * @param arr The array to convert.
 * @returns The resulting map.
 */
const toMap = (arr) => arr.reduce((obj, item) => ({
    ...obj,
    [item.key]: item,
}), {});
exports.toMap = toMap;
/**
 * Searches for an item in an array by key and raises an error if the item is not found.
 *
 * @param arr The array to search.
 * @param map_name The name of the data being searched to use for the error message.
 * @returns The item found.
 */
const createFindByKeyUsingArray = (arr, map_name) => (key) => {
    const result = arr.find((item) => item.key === key);
    if (result === undefined) {
        throw new Error(`Unable to find data about "${key}" in "${map_name}"`);
    }
    return result;
};
exports.createFindByKeyUsingArray = createFindByKeyUsingArray;
